import React, { Fragment } from 'react'
import '../css/Hero.css'
import logo from "../assets/images/logos/MSA_Square_NEG.svg"

interface IHeroProps{
    title: string,
    heroImage: string,
    button?: JSX.Element
}

function Hero(props: IHeroProps) {
    return (
        <div className="bg-light hero" style={{backgroundImage: `url(${props.heroImage})`}}>
            <div className="intro-text">
                <div className="py-5 my-auto mx-auto">
                    <img className="logo-image" src={logo} alt="MSA Logo"/>
                    <h1 className="px-2">MICROSOFT STUDENT ACCELERATOR</h1>
                    <h3 className="font-thin">{props.title}</h3>
                    {/* If button string exists then render the button, otherwise render an empty fragment */}
                    {
                    /* Currently takes you to the bottom of the page. Can replace with a redirect to register. */
                    props.button === undefined ? 
                    <Fragment/> 
                    : 
                    <Fragment>
                        {props.button}
                    </Fragment>  
                    }
                </div>
            </div>
        </div>
    )
}

export default Hero;